import i18n from '@/i18n'
import { isObjEmpty } from '@/utils/utils'

export default {
    data(): any {
        return {}
    },

    methods: {
        getTranslatedText(text: string, xargs: any = {}) {
            if (!text) {
                return
            }
            const rsText = text.toString().toLowerCase()
            let translatedText: any = i18n.t(rsText.toString())

            if (!isObjEmpty(xargs)) {
                for (const key in xargs) {
                    translatedText = translatedText.replace('[' + key + ']', xargs[key])
                }
            }
            const capitalizedSentence = translatedText.charAt(0).toUpperCase() + translatedText.slice(1)
            return capitalizedSentence
        },
    },
}
